import { Companies } from "@stories/pages/Contractor/Companies/Companies";

interface DirectoryViewProps {
  isOpen: boolean;
  handleDrawerOpen: () => void;
}

export const DirectoryView = ({
  isOpen,
  handleDrawerOpen,
}: DirectoryViewProps) => {
  return <Companies />;
};
